import {
  NOTIFICATION_SETTINGS_REQUEST, NOTIFICATION_SETTINGS_SUCCESS, NOTIFICATION_SETTINGS_FAILURE,
  NOTIFICATION_SETTINGS_UPDATE_REQUEST, NOTIFICATION_SETTINGS_UPDATE_SUCCESS, NOTIFICATION_SETTINGS_UPDATE_FAILURE
} from '../actions/notificationSettings'

const INITIAL_STATE = {
  settings: null,
  error: null,
  loading: false,
  saving: false
}

const notificationSettingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NOTIFICATION_SETTINGS_REQUEST:
      return { ...state, error: null, loading: true }
    case NOTIFICATION_SETTINGS_SUCCESS:
      return { ...state, settings: action.response, error: null, loading: false }
    case NOTIFICATION_SETTINGS_FAILURE:
      return { ...state, error: action.error, loading: false }

    case NOTIFICATION_SETTINGS_UPDATE_REQUEST:
      return { ...state, error: null, saving: true }
    case NOTIFICATION_SETTINGS_UPDATE_SUCCESS:
      return { ...state, settings: action.response, error: null, saving: false }
    case NOTIFICATION_SETTINGS_UPDATE_FAILURE:
      return { ...state, error: action.error, saving: false }

    default:
      return state
  }
}

export default notificationSettingsReducer
